import { useEffect } from "react";
import { motion } from "motion/react";
import useWindowDimensions from "../hooks/useWindowDimensions";

export default function AppModal({ onClose, content }) {
  const { width, height } = useWindowDimensions();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "visible";
    };
  }, []);

  const offset = width < 768 ? height : 100;

  const states = {
    initial: { y: offset, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: offset, opacity: 0 },
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/30 flex justify-center items-start pt-12 pb-0 z-50 overflow-scroll"
    >
      <motion.div
        {...states}
        onClick={() => {}}
        className="bg-white w-full md:w-[95%] md:md:h-[90%] rounded-t-xl md:rounded-b-xl shadow-lg flex flex-col md:flex-row justify-start overflow-scroll z-[999]"
      >
        <div
          style={{ background: content.theme.accent }}
          className="w-full h-full overflow-hidden md:w-1/2 flex flex-col justify-center items-center pt-6"
        >
          <div className="h-1/2 w-full px-12 flex flex-col justify-center items-center">
            <img
              alt=""
              src={require(`../routes/posts/apps/${content.name}/${content.icon}`)}
            />
            <h2
              style={{ color: content.theme.textColor }}
              className="mb-4 text-3xl font-serif font-bold mt-4"
            >
              {content.name}
            </h2>
          </div>
          <div className="h-1/2">
            <img
              alt=""
              src={require(`../routes/posts/apps/${content.name}/Screenshot.png`)}
            />
          </div>
        </div>
        <div className="w-full md:w-1/2 p-6 md:p-12">
          <div className="flex justify-end mb-4">
            <button onClick={() => onClose(null)}>Close</button>
          </div>
          <div>
            <p className="inline-block border border-slate-200 bg-slate-100 px-2 py-1 rounded-md mb-4">
              {content.status}
            </p>
            <p className="text-lg font-bold mb-4">{content.tagline}</p>
            <p style={{ whiteSpace: "pre-line" }} className="text-base">
              {content.description}
            </p>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
